// JsFromRoutes CacheKey 02f1db7dc6bd38ba326eeeea22eda31c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  list: definePathHelper('get', '/api/v1/search/:q'),
}
